import { render, staticRenderFns } from "./mixChart.vue?vue&type=template&id=2f05da01"
import script from "./mixChart.vue?vue&type=script&lang=js"
export * from "./mixChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports